import React from 'react'
import './guidep.css'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhotoFilm, faVideo,faStar,faCalendarCheck,faCalendarDays, faCheck,faCircleInfo,faUser, faClock,faLocationDot,faUsers,faChevronDown} from '@fortawesome/free-solid-svg-icons'
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import PackageSlider from "./Component/PackageSlider";

const packages = [
  {
    title: "Mt Everest Heli Tour",
    location: "Lukla",
    days: "4 Hours",
    duration: "4 Hours",
    group: "Min 1",
    difficulty: "Easy",
    price: 1375,
    image: "/img/Heli.webp",
    link: "/tours/everest-base-camp"
  },
  {
    title: "Everest Base Camp Trek",
    location: "Nepal",
    days: 14,
    group: "Max 12",
    difficulty: "Hard",
    price: 1299,
    duration: "14 Days",
    image: "/img/lumbini.jpg",
    link: "/tours/everest-base-camp"
  },
  {
    title: "Annapurna Circuit Trek",
    location: "Nepal",
    days: 12,
    group: "Max 10",
    difficulty: "Medium",
    price: 999,
    duration: "12 Days",
    image: "/img/Heli1.webp",
    link: "/tours/annapurna-circuit"
  },
  {
    title: "Kathmandu City Tour",
    location: "Nepal",
    days: 3,
    group: "Private",
    difficulty: "Easy",
    price: 299,
    duration: "3 Days",
    image: "/img/Chitwan.jpg",
    link: "/tours/kathmandu-tour"
  }
];
const Chineseguide = () => {
  return (
    <main className='guidep-back'>
      <section className='cguide-top'> <h2>Chinese Speaking Guide</h2>
      <div className="card-rating dis-cg">
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <p>5.0</p>
        </div>
      </section>
      <section className='guidep-sec'>
        <div className="guidep-left">
          <div className="cguideimage">
          <Swiper
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
        breakpoints={{
          768: {
            slidesPerView: 1,
          },
        }}
        className='cgred'
      >
         <SwiperSlide>
          <div className="guidechinese-card">
            <img src="/img/bandipur.jpg"/>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="guidechinese-card">
            <img src="/img/tal barahi.webp"/>
          </div>
        </SwiperSlide>
        <div className='c-video'><FontAwesomeIcon icon={faVideo}></FontAwesomeIcon></div>
       <div className="c-gallery"><FontAwesomeIcon icon={faPhotoFilm}></FontAwesomeIcon>Gallery</div>
      </Swiper>
      <div className="chinesegiude-desktop">
      <div className="chineseguide-desktop-image-left"><
      img src="/img/pokhara4.jpg"/>
      <div className='c-video'><FontAwesomeIcon icon={faVideo}></FontAwesomeIcon></div>
              <div className="c-gallery"><FontAwesomeIcon icon={faPhotoFilm}></FontAwesomeIcon>Gallery</div></div>
      <div className="rightcg">
      <div className="cg-right-1"><img src="/img/bouddha.jpg" alt="error" /></div>
      <div className="cg-right-2">
      <div className="sec-cg"><img src="/img/Dhampus.jpg" alt="error" /></div>
      <div className="sec-cg"><img src="/img/tal barahi.webp" alt="error" /></div>
      </div>
      </div>
     </div>
             
          </div>
          <section className='cguide-topg'> <h2>Chinese Speaking Guide</h2></section>
          <div className="card-rating g-star">
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <FontAwesomeIcon icon={faStar} />
          <p>5.0</p>
        </div>
        <section className='g-background'>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Esse sit, deserunt quasi alias quisquam eaque, nostrum rerum aspernatur aut maiores cumque, minus expedita facilis adipisci ex eveniet nihil modi non.</section>
        <div>
        <h2 className='tnow'>Things To Know</h2>
         {/* Item 1 */}
         <div className="things-item">
          <div className="things-icon">
            <FontAwesomeIcon icon={faCalendarCheck} />
          </div>
          <div className="things-content">
            <h4>Reserve now & pay later</h4>
            <p>
              Keep your travel plans flexible — book your spot and pay nothing today.
            </p>
          </div>
        </div>

        {/* Item 2 */}
        <div className="things-item">
          <div className="things-icon">
            <FontAwesomeIcon icon={faClock} />
          </div>
          <div className="things-content">
            <h4>Duration</h4>
            <p>10 hours</p>
          </div>
        </div>

        {/* Item 3 */}
        <div className="things-item">
          <div className="things-icon">
            <FontAwesomeIcon icon={faUser} />
          </div>
          <div className="things-content">
            <h4>Live Tour Guide</h4>
            <p>English, Chinese, Hindi</p>
          </div>
        </div>
        </div>
  
        <div className="guidebelow-container">

        {/* Highlights */}
        <div className="guidebelow-section">
          <div className="guidebelow-wrapper">
            <div className="guidebelow-title">Highlights</div>
  
            <div className="guidebelow-content">
              <ul className="guidebelow-list">
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCheck} className="guidebelow-icon" />
                  Explore UNESCO heritage sites
                </li>
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCheck} className="guidebelow-icon" />
                  Professional local guide
                </li>
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCheck} className="guidebelow-icon" />
                  Comfortable private transport
                </li>
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCheck} className="guidebelow-icon" />
                  Flexible booking options
                </li>
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCheck} className="guidebelow-icon" />
                  Perfect for all travelers
                </li>
              </ul>
            </div>
          </div>
        </div>
  
        {/* Full Description */}
        <div className="guidebelow-section">
          <div className="guidebelow-wrapper">
            <div className="guidebelow-title">Full description</div>
  
            <div className="guidebelow-content">
              <div className="guidebelow-info">
                <FontAwesomeIcon icon={faCircleInfo} className="guidebelow-icon" />
                <p className="guidebelow-text">
                  Discover Nepal with a perfectly designed experience covering
                  culture, history, and scenic beauty. Enjoy a smooth journey with
                  expert guidance and flexible travel planning.
                </p>
              </div>
            </div>
          </div>
        </div>
  
        {/* Guide Details */}
        <div className="guidebelow-section">
          <div className="guidebelow-wrapper">
            <div className="guidebelow-title">Guide details</div>
  
            <div className="guidebelow-content">
              <div className="guidebelow-grid">
                <div className="guidebelow-grid-item">
                  <FontAwesomeIcon icon={faUser} className="guidebelow-icon" />
                  Live tour guide: English
                </div>
  
                <div className="guidebelow-grid-item">
                  <FontAwesomeIcon icon={faClock} className="guidebelow-icon" />
                  Duration: 10 hours
                </div>
  
                <div className="guidebelow-grid-item">
                  <FontAwesomeIcon icon={faLocationDot} className="guidebelow-icon" />
                  Pickup included
                </div>
  
                <div className="guidebelow-grid-item">
                  <FontAwesomeIcon icon={faUser} className="guidebelow-icon" />
                  Private / Shared group
                </div>
              </div>
            </div>
          </div>
        </div>
  
        {/* Includes */}
        <div className="guidebelow-section">
          <div className="guidebelow-wrapper">
            <div className="guidebelow-title">Includes</div>
  
            <div className="guidebelow-content">
              <ul className="guidebelow-list">
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCheck} className="guidebelow-icon" />
                  Hotel pickup and drop-off
                </li>
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCheck} className="guidebelow-icon" />
                  Professional guide
                </li>
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCheck} className="guidebelow-icon" />
                  Transportation
                </li>
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCheck} className="guidebelow-icon" />
                  All taxes and fees
                </li>
              </ul>
            </div>
          </div>
        </div>
  
        {/* Important Information */}
        <div className="guidebelow-section">
          <div className="guidebelow-wrapper">
            <div className="guidebelow-title">Important information</div>
  
            <div className="guidebelow-content">
              <ul className="guidebelow-list">
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCircleInfo} className="guidebelow-icon" />
                  Bring comfortable shoes
                </li>
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCircleInfo} className="guidebelow-icon" />
                  Carry valid ID
                </li>
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCircleInfo} className="guidebelow-icon" />
                  Not wheelchair accessible
                </li>
                <li className="guidebelow-item">
                  <FontAwesomeIcon icon={faCircleInfo} className="guidebelow-icon" />
                  Weather dependent activity
                </li>
              </ul>
            </div>
          </div>
        </div>
  
      </div>
 
        </div>
        <div className="guidep-right">
        <div className="guidecp-card">
      <div className="guide-price-section">
        <span className="guide-from">From</span>
        <h2 className="guide-price">$160 <span>per person</span></h2>
      </div>

      <div className="guide-input-group">
        <div className="guide-input">
          <div className="guide-input-left">
            <FontAwesomeIcon icon={faUsers} />
            <span>Participants</span>
          </div>
          <FontAwesomeIcon icon={faChevronDown} />
        </div>

        <div className="guide-input">
          <div className="guide-input-left">
            <FontAwesomeIcon icon={faCalendarDays} />
            <span>Select date</span>
          </div>
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
      </div>

      <button className="guide-btn-cp">Check availability</button>

      <hr className="guide-divider" />

      <div className="guide-info">
        <div className="guide-info-item">
          <div className="guide-icon">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div>
            <h4>Free cancellation</h4>
            <p>Cancel up to 24 hours in advance for a full refund</p>
          </div>
        </div>

        <div className="guide-info-item">
          <div className="guide-icons">
          <FontAwesomeIcon icon={faCheck} />
          </div>
          <div>
            <h4>Reserve now & pay later</h4>
            <p>
              Keep your travel plans flexible — book your spot and pay nothing
              today. <span className="guide-read">Read more</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    </div>
   
      </section>
      <h2 className="hws">you may also like</h2>
     <PackageSlider packages={packages} />
      <section className='sticky-bott'>
     <div className="booking-btn">
                  <button>Hire Now</button>
                  <button>Enquiry Now</button>
    </div>
     </section>
    </main>
  )
}

export default Chineseguide